<template>
    <div class="ix-formbuilder-component-summary-content">
        <div class="formbuilder-component boxed padding" v-if="displayMode == 'readable' || displayMode == 'fillable'">
            <div class="mb-small">
                <p class="formbuilder-component-label">{{ currentField.label }}</p>
                    <p class="formbuilder-component-help" v-if="currentField.helper">{{ currentField.helper }}</p>
            </div>
            <table class="formbuilder-table">
                <thead v-show="currentField.position == 'horizontal' || currentField.position == 'both'">
                    <tr>
                        <th v-if="currentField.position =='both'"></th>
                        <th v-for="(label,i) in currentField.horizontal_labels" :key="i">{{ label }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row,r) in currentField.rows" v-if="currentField.rows[r]" :key="r">
                        <th v-if="currentField.position == 'vertical' || currentField.position == 'both'">
                            <span v-if="currentField.vertical_labels && currentField.vertical_labels.length && currentField.vertical_labels[r]">
                                    {{ currentField.vertical_labels[r] }}
                            </span>
                        </th>
                        <td v-for="(column,c) in currentField.horizontal_labels" :key="c">
                            <span v-if="displayMode == 'readable'">{{ currentField.rows[r][c] }}</span>
                            <input type="text" v-if="displayMode == 'fillable'" class="form-control" v-model="currentField.rows[r][c]"/>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div v-if="displayMode == 'summary'" class="ix-formbuilder-component-summary-info">
            <div class="ix-formbuilder-component-summary-handle">
                <span class="ix-drag-icon handle-line"></span>
            </div>
            <div class="ix-formbuilder-component-summary-icon" data-toggle="tooltip" data-placement="top" title="Tableau">
                <div class="ix-formbuilder-icon">
                    <i class="far fa-table"></i>
                </div>
            </div>
            <div class="ix-formbuilder-component-summary-content">
                <span class="ix-formbuilder-component-summary-label" v-bind:class="{'required': currentField.required}">{{ currentField.label }}</span>
                <span class="ix-formbuilder-component-summary-help" v-if="currentField.helper">{{ currentField.helper }}</span>
                <ul class="ix-formbuilder-component-summary-options">
                    <li>Nombre de lignes : {{ currentField.rows_count }}</li>
                    <li>Nombre de colonnes : {{ currentField.columns_count }}</li>
                    <li>Position de l'en-tête : 
                        <span v-if="currentField.position == 'horizontal'">En-tête horizontale</span>
                        <span v-if="currentField.position == 'vertical'">En-tête verticale</span>
                        <span v-if="currentField.position == 'both'">En-tête horizontale et verticale</span>
                    </li>
                </ul>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "TableComponent",
        props: ['currentField','showIcon','displayMode'],
    }
</script>
